export default (a, b) => {
  if (typeof a !== 'object' || typeof b !== 'object') return false;

  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(b)) if (a[key] !== b[key]) return true;

  return false;
};
